export { paths, demoPaths, sadcPaths } from './paths';
